import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { MdOutlineSdCardAlert } from 'react-icons/md'
import { TbAlertTriangle } from 'react-icons/tb'
import styles from './PatientAlerts.module.scss'
import PropTypes from 'prop-types'

const PatientAlerts = ({ alerts, patientId }) => {
  const navigate = useNavigate()
  const [outOfRangeAlerts, setOutOfRangeAlerts] = useState([])
  const [missingAlerts, setMissingAlerts] = useState([])
  const [notDoneAlerts, setNotDoneAlerts] = useState([])
  const [abnormallyHighAlerts, setAbnormallyHighAlerts] = useState([])
  const [abnormallyLowAlerts, setAbnormallyLowAlerts] = useState([])
  const [abnormalResultAlerts, setAbnormalResultAlerts] = useState([])

  useEffect(() => {
    filterAlerts(alerts)
  }, [alerts])

  const filterAlerts = (alerts) => {
    setMissingAlerts([])
    setOutOfRangeAlerts([])
    setNotDoneAlerts([])
    setAbnormallyHighAlerts([])
    setAbnormallyLowAlerts([])
    setAbnormalResultAlerts([])
    Object.keys(alerts).forEach((alert) => {
      if (alert.toLowerCase().includes('missing')) {
        setMissingAlerts((missingAlerts) => [...missingAlerts, alert])
      } else if (alert.toLowerCase().includes('out of range')) {
        setOutOfRangeAlerts((outOfRangeAlerts) => [...outOfRangeAlerts, alert])
      } else if (alert.toLowerCase().includes('not done')) {
        setNotDoneAlerts((notDoneAlerts) => [...notDoneAlerts, alert])
      } else if (alert.toLowerCase().includes('abnormally high')) {
        setAbnormallyHighAlerts((abnormallyHighAlerts) => [
          ...abnormallyHighAlerts,
          alert
        ])
      } else if (alert.toLowerCase().includes('abnormally low')) {
        setAbnormallyLowAlerts((abnormallyLowAlerts) => [
          ...abnormallyLowAlerts,
          alert
        ])
      } else if (alert.toLowerCase().includes('abnormal result')) {
        setAbnormalResultAlerts((abnormalResultAlerts) => [
          ...abnormalResultAlerts,
          alert
        ])
      }
    })
  }

  const formatColors = (action) => {
    action = action.toLowerCase().replace('not done ', '')
    action = action.toLowerCase().replace('abnormally high ', '')
    action = action.toLowerCase().replace('abnormally low ', '')
    action = action.toLowerCase().replace('abnormal result ', '')
    return COLOR_MAPPING[action]
  }

  const COLOR_MAPPING = {
    'blood pressure': '#ffba00',
    temperature: '#ea540b',
    spo2: '#4285f4',
    ecg: '#69be28',
    weight: '#8B4513', // Replaced grey with #8B4513 (SaddleBrown)
    survey: '#6A5ACD' // Replaced grey with #6A5ACD (SlateBlue)
  }

  const goToAlert = (alert) => {
    navigate(`/patient/${patientId}`, { state: { alert } })
  }

  return (
    <div className={styles.alerts}>
      {outOfRangeAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge badgeContent={alerts[alert].count}>
              <IconButton
                size="small"
                className="range-alert"
                style={{ color: formatColors(alert) }}
              >
                <TbAlertTriangle />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
      {missingAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge
              badgeContent={alerts[alert].count}
              style={{ opacity: '0.6' }}
            >
              <IconButton
                size="small"
                className="missing-alert"
                style={{ color: formatColors(alert) }}
              >
                <MdOutlineSdCardAlert />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
      {notDoneAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge badgeContent={alerts[alert].count}>
              <IconButton
                size="small"
                className="not-done-alert"
                style={{ color: formatColors(alert) }}
              >
                <TbAlertTriangle />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
      {abnormallyHighAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge badgeContent={alerts[alert].count}>
              <IconButton
                size="small"
                className="abnormally-high-alert"
                style={{ color: formatColors(alert) }}
              >
                <TbAlertTriangle />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
      {abnormallyLowAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge badgeContent={alerts[alert].count}>
              <IconButton
                size="small"
                className="abnormally-low-alert"
                style={{ color: formatColors(alert) }}
              >
                <TbAlertTriangle />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
      {abnormalResultAlerts.map((alert, index) => (
        <div
          key={index}
          className={styles.flag}
          onClick={() => goToAlert(alerts[alert].latest_alert)}
        >
          <Tooltip title={alert}>
            <Badge badgeContent={alerts[alert].count}>
              <IconButton
                size="small"
                className="abnormal-result-alert"
                style={{ color: formatColors(alert) }}
              >
                <TbAlertTriangle />
              </IconButton>
            </Badge>
          </Tooltip>
        </div>
      ))}
    </div>
  )
}

export default PatientAlerts

PatientAlerts.propTypes = {
  alerts: PropTypes.object,
  patientId: PropTypes.string
}
